import PageHeader from './page-header';

export type { PageHeaderProps } from './page-header';

export default PageHeader;
